import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import * as React from 'react';
import { useRouter } from 'next/router';
import GlobalStyles from '@mui/material/GlobalStyles';
import { styled, alpha } from '@mui/material/styles';
import NProgress from 'nprogress';
import AppBar from '@mui/material/AppBar';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import GitHubIcon from '@mui/icons-material/GitHub';
import NProgressBar from '@mui/docs/NProgressBar';
import { debounce } from '@mui/material/utils';
import SvgHamburgerMenu from 'docs/src/icons/SvgHamburgerMenu';
import AppNavDrawer from 'docs/src/modules/components/AppNavDrawer';
import AppSettingsDrawer from 'docs/src/modules/components/AppSettingsDrawer';
import Notifications from 'docs/src/modules/components/Notifications';
import PageContext from 'docs/src/modules/components/PageContext';
import { useTranslate } from '@mui/docs/i18n';
import LogoWithCopyMenu from 'docs/src/components/action/LogoWithCopyMenu';
import AppFrameBanner from 'docs/src/components/banner/AppFrameBanner';
import { DemoPageThemeProvider } from 'docs/src/theming';
import { pathnameToLanguage } from 'docs/src/modules/utils/helpers';
import SearchButton from './SearchButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var nProgressStart = debounce(function () {
  NProgress.start();
}, 200);
function nProgressDone() {
  nProgressStart.clear();
  NProgress.done();
}
export function NextNProgressBar() {
  var router = useRouter();
  React.useEffect(function () {
    var handleRouteChangeStart = function handleRouteChangeStart(url, _ref) {
      var shallow = _ref.shallow;
      if (!shallow) {
        nProgressStart();
      }
    };
    var handleRouteChangeDone = function handleRouteChangeDone(url, _ref2) {
      var shallow = _ref2.shallow;
      if (!shallow) {
        nProgressDone();
      }
    };
    router.events.on('routeChangeStart', handleRouteChangeStart);
    router.events.on('routeChangeComplete', handleRouteChangeDone);
    router.events.on('routeChangeError', handleRouteChangeDone);
    return function () {
      router.events.off('routeChangeStart', handleRouteChangeStart);
      router.events.off('routeChangeComplete', handleRouteChangeDone);
      router.events.off('routeChangeError', handleRouteChangeDone);
    };
  }, [router]);
  return /*#__PURE__*/_jsx(NProgressBar, {});
}
var sx = {
  minWidth: {
    sm: 160
  }
};
var AppSearch = /*#__PURE__*/React.lazy(function () {
  return import('docs/src/modules/components/AppSearch');
});
export function DeferredAppSearch() {
  return /*#__PURE__*/_jsx(React.Suspense, {
    fallback: /*#__PURE__*/_jsx(SearchButton, {
      sx: sx
    }),
    children: /*#__PURE__*/_jsx(AppSearch, {
      sx: sx
    })
  });
}
var RootDiv = styled('div')(function (_ref3) {
  var theme = _ref3.theme;
  return _extends({
    display: 'flex'
  }, theme.applyDarkStyles({
    background: (theme.vars || theme).palette.primaryDark[900]
  }));
});
var StyledAppBar = styled(AppBar, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'disablePermanent';
  }
})(function (_ref4) {
  var theme = _ref4.theme;
  return _extends({
    padding: theme.spacing(1.5),
    transition: theme.transitions.create('width'),
    justifyContent: 'center',
    boxShadow: 'none',
    backdropFilter: 'blur(8px)',
    borderBottom: "1px solid ".concat((theme.vars || theme).palette.divider),
    backgroundColor: 'hsla(0, 0%, 100%, 0.6)',
    color: (theme.vars || theme).palette.grey[800]
  }, theme.applyDarkStyles({
    backgroundColor: alpha(theme.palette.primaryDark[900], 0.6),
    color: (theme.vars || theme).palette.grey[500]
  }), {
    variants: [{
      props: function props(_ref5) {
        var disablePermanent = _ref5.disablePermanent;
        return disablePermanent;
      },
      style: {
        boxShadow: 'none'
      }
    }, {
      props: function props(_ref6) {
        var disablePermanent = _ref6.disablePermanent;
        return !disablePermanent;
      },
      style: _defineProperty({}, theme.breakpoints.up('lg'), {
        width: 'calc(100% - var(--MuiDocs-navDrawer-width))'
      })
    }]
  });
});
var NavIconButton = styled(IconButton, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'disablePermanent';
  }
})(function (_ref7) {
  var theme = _ref7.theme;
  return {
    variants: [{
      props: {
        disablePermanent: false
      },
      style: _defineProperty({}, theme.breakpoints.up('lg'), {
        display: 'none'
      })
    }]
  };
});
var StyledAppNavDrawer = styled(AppNavDrawer)(function (_ref8) {
  var theme = _ref8.theme;
  return {
    variants: [{
      props: {
        disablePermanent: false
      },
      style: _defineProperty({}, theme.breakpoints.up('lg'), {
        flexShrink: 0,
        width: 'var(--MuiDocs-navDrawer-width)'
      })
    }]
  };
});
export var HEIGHT = 57;
export default function AppFrame(props) {
  var children = props.children,
    _props$disableDrawer = props.disableDrawer,
    disableDrawer = _props$disableDrawer === void 0 ? false : _props$disableDrawer,
    className = props.className,
    _props$BannerComponen = props.BannerComponent,
    BannerComponent = _props$BannerComponen === void 0 ? AppFrameBanner : _props$BannerComponen;
  var t = useTranslate();
  var router = useRouter();
  var _pathnameToLanguage = pathnameToLanguage(router.asPath),
    canonicalAs = _pathnameToLanguage.canonicalAs;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mobileOpen = _React$useState2[0],
    setMobileOpen = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    settingsOpen = _React$useState4[0],
    setSettingsOpen = _React$useState4[1];
  var closeDrawer = React.useCallback(function () {
    return setMobileOpen(false);
  }, []);
  var openDrawer = React.useCallback(function () {
    return setMobileOpen(true);
  }, []);
  var _React$useContext = React.useContext(PageContext),
    activePage = _React$useContext.activePage,
    productIdentifier = _React$useContext.productIdentifier;
  var disablePermanent = (activePage == null ? void 0 : activePage.disableDrawer) === true || disableDrawer === true;
  var isJoy = canonicalAs.startsWith('/joy-ui/');
  return /*#__PURE__*/_jsx(DemoPageThemeProvider, {
    hasJoy: isJoy,
    children: /*#__PURE__*/_jsxs(RootDiv, {
      className: className,
      children: [/*#__PURE__*/_jsxs(StyledAppBar, {
        disablePermanent: disablePermanent,
        sx: {
          minHeight: 'var(--MuiDocs-header-height)'
        },
        children: [/*#__PURE__*/_jsx(GlobalStyles, {
          styles: {
            ':root': {
              '--MuiDocs-header-height': "".concat(HEIGHT, "px")
            }
          }
        }), /*#__PURE__*/_jsxs(Stack, {
          direction: "row",
          sx: {
            alignItems: 'center',
            position: 'relative',
            width: '100%'
          },
          children: [/*#__PURE__*/_jsx(NavIconButton, {
            edge: "start",
            color: "primary",
            size: "small",
            "aria-label": t('appFrame.openDrawer'),
            disablePermanent: disablePermanent,
            onClick: function onClick() {
              return setMobileOpen(true);
            },
            sx: {
              ml: '1px'
            },
            children: /*#__PURE__*/_jsx(SvgHamburgerMenu, {})
          }), /*#__PURE__*/_jsx(Box, {
            sx: {
              display: {
                xs: 'flex',
                md: 'flex',
                lg: 'none'
              }
            },
            children: /*#__PURE__*/_jsx(LogoWithCopyMenu, {
              logo: productIdentifier.logo,
              logoSvgString: productIdentifier.logoSvg,
              wordmarkSvgString: productIdentifier.wordmarkSvg,
              marginLeft: true
            })
          }), /*#__PURE__*/_jsxs(Stack, {
            direction: "row",
            spacing: 1,
            useFlexGap: true,
            sx: {
              ml: 'auto'
            },
            children: [/*#__PURE__*/_jsx(BannerComponent, {}), /*#__PURE__*/_jsx(DeferredAppSearch, {}), /*#__PURE__*/_jsx(Tooltip, {
              title: t('appFrame.github'),
              enterDelay: 300,
              children: /*#__PURE__*/_jsx(IconButton, {
                component: "a",
                color: "primary",
                size: "small",
                href: process.env.SOURCE_CODE_REPO,
                "data-ga-event-category": "header",
                "data-ga-event-action": "github",
                children: /*#__PURE__*/_jsx(GitHubIcon, {
                  fontSize: "small"
                })
              })
            }), /*#__PURE__*/_jsx(Notifications, {}), /*#__PURE__*/_jsx(Tooltip, {
              title: t('appFrame.toggleSettings'),
              enterDelay: 300,
              children: /*#__PURE__*/_jsx(IconButton, {
                color: "primary",
                size: "small",
                onClick: function onClick() {
                  return setSettingsOpen(true);
                },
                children: /*#__PURE__*/_jsx(SettingsIcon, {
                  fontSize: "small"
                })
              })
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx(StyledAppNavDrawer, {
        disablePermanent: disablePermanent,
        onClose: closeDrawer,
        onOpen: openDrawer,
        mobileOpen: mobileOpen
      }), children, /*#__PURE__*/_jsx(AppSettingsDrawer, {
        onClose: function onClose() {
          return setSettingsOpen(false);
        },
        open: settingsOpen
      })]
    })
  });
}
false ? void 0 : void 0;